import { Injectable } from '@angular/core';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader';
import { WebGLRenderer } from 'three';
import { sRGBEncoding } from 'three';
import { TextureLoader } from 'three';
import { PMREMGenerator } from 'three';
import { LoadingManager } from 'three';


/**
 * Holds whatever threejs component must be preserved across app
 */
@Injectable({
    providedIn: 'root'
})
export class ThreeService {

    //gltfLoader: GLTFLoader;
    // renderer: WebGLRenderer;
    textureLoader: TextureLoader = new TextureLoader();
    //pmremGenerator: PMREMGenerator;
    //gltf: any;
    private dracoLoader: DRACOLoader = new DRACOLoader();

    constructor() {
        this.dracoLoader.setDecoderPath('assets/draco/');
        this.dracoLoader.preload();
    }

    createRenderer(): WebGLRenderer {
        const renderer = new WebGLRenderer(
            {
                // canvas,
                //context: ctx as any,
                antialias: true,
                //alpha: true,
                powerPreference: 'high-performance',
                precision: 'highp',
                depth: true,
            });
        renderer.physicallyCorrectLights = true;
        renderer.outputEncoding = sRGBEncoding;
        // https://threejs.org/docs/#api/en/renderers/WebGLRenderer.physicallyCorrectLights
        renderer.physicallyCorrectLights = true;
        renderer.setClearColor(0x000000, 0);
        return renderer;
    }

    createPmGenerator(renderer){
        return new PMREMGenerator(renderer);
    }

    createGltfLoader(renderer){
        return new GLTFLoader()
            .setCrossOrigin('anonymous')
            .setDRACOLoader(this.dracoLoader)
            .setKTX2Loader(new KTX2Loader().detectSupport(renderer));
    }
}
